import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '~/state/hooks';
import { selectDiscipline, setDiscipline } from '~/state/discipline';
import { Disciplines } from '~/utilities';
import { hasFeatureFlag } from '@janeapp/feature-flags-client';

export const useSyncReduxToUrlParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const discipline = useAppSelector(selectDiscipline);
  const navigate = useNavigate();

  const isValidDiscipline = (discipline: string | null): boolean => {
    return discipline !== null && discipline in Disciplines;
  };

  // URL → Redux (hydration)
  useEffect(() => {
    if (!hasFeatureFlag('SEARCH_STATE_HISTORY')) return;

    const urlDiscipline = searchParams.get('discipline');

    if (
      urlDiscipline &&
      urlDiscipline !== discipline &&
      isValidDiscipline(urlDiscipline)
    ) {
      dispatch(setDiscipline(urlDiscipline));
    }
  }, [searchParams, discipline, dispatch]);

  // Redux → URL (sync)
  useEffect(() => {
    if (!hasFeatureFlag('SEARCH_STATE_HISTORY')) return;

    const urlDiscipline = searchParams.get('discipline');

    // Check for invalid discipline first
    if (urlDiscipline && !isValidDiscipline(urlDiscipline)) {
      navigate(
        `/error?type=invalid-discipline&value=${encodeURIComponent(urlDiscipline)}`,
        { replace: false }
      );
      return;
    }

    if (discipline && discipline !== urlDiscipline) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set('discipline', discipline);
      setSearchParams(newParams, { replace: false });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [discipline]);
};
